// extracted by mini-css-extract-plugin
export default {"btnpwd":"bbf6972499"};